import { AbstractValidatable, ValidationErrorsObject } from "frontend-core";

export enum AuthMethod {
  Code = 'code',
  Call = 'call',
}

export enum AuthStep {
  First = 1,
  Second = 2,
}

export class Credentials extends AbstractValidatable {
  public f2aCode?: string;
  public ya_captcha?: string;
  public method = AuthMethod.Code;
  public step = AuthStep.First;

  get password(): string {
    return this._password;
  }

  set password(value: string) {
    this._password = value;
  }

  get login(): string {
    return this._login;
  }

  set login(value: string) {
    this._login = value;
  }

  public readonly errors: ValidationErrorsObject<{
    login: string[];
    password: string[];
  }>;

  private _login: string;
  private _password: string;

  constructor(
    login?: string,
    password?: string,
    ya_captcha?: string,
    f2aCode?: string,
  ) {
    super();

    this._login = login || "";
    this._password = password || "";
    this.ya_captcha = ya_captcha;
    this.f2aCode = f2aCode;

    this.errors = {
      login: [],
      password: [],
    };
  }
}
